import * as React from "react";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { IncomeArrangementType, getPaymentTypeOptions, getSourceFromOptions, getSourceFromString, getString } from "../../../NewOneOffIncomePaymentWizard/Resource/Content";
import { User } from "../../../../../../../Wrap/Models/Models/User/User";
import { UserStore } from "../../../../../Stroes/Variable";
import { RestrictionStore } from "../../../Common/Restrictions/Variable";
import { DrawdownPaymentSourceAllocation } from "../../../../../../../Wrap/Models/Domains/Drawdown/DrawdownPaymentSourceAllocation";
import { DrawdownPaymentDestinationAllocation } from "../../../../../../../Wrap/Models/Domains/Drawdown/DrawdownPaymentDestinationAllocation";
import { DrawdownSinglePayment } from "../../../../../../../Wrap/Models/Domains/Drawdown/DrawdownSinglePayment";
import { DrawdownSinglePaymentInstruction } from "../../../../../../../Wrap/Models/Domains/Drawdown/DrawdownSinglePaymentInstruction";
import { CurrencyCode } from "../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { Money } from "../../../../../../../Wrap/Core/DataTypes/Money";
import { InvestmentAllocation } from "../../../../../../../Wrap/Models/Domains/Investment/InvestmentAllocation";
import { FlexiPensionArrangementDetail } from "../../../../../../../Wrap/Models/Models/Processes/Drawdown/FlexiPensionArrangementDetail";
import { CappedPensionArrangementDetail } from "../../../../../../../Wrap/Models/Models/Processes/Drawdown/CappedPensionArrangementDetail";
import { OneOffIncomePaymentModel } from "../../../../../../../Wrap/Models/Models/Processes/Drawdown/OneOffIncomePaymentModel";
import { UserAssetsAllocationData, UserAssetsAllocationTable } from "../../../NewOneOffIncomePaymentWizard/Components/Shared/UserAssetsAllocationTable";
import { toDp } from "../../../../../../../react-core/Utils/Math";
import { isNullOrEmpty } from "../../../../../../../react-core/Utils/Arrays";
import { MoneyDisplayHelper } from "../../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { Typography } from "../../../../../../Shared/Typography/Typography";
import { GENERIC_RESTRICTIONS_MESSAGE } from "../../../../../../Shared/Common/UserMessages";
import { Alert } from "../../../../../../Shared/Components/Alert";
import { RadiosEditor } from "../../../../../../../react-core/Html/RadiosEditor";
import { AlertType } from "../../../../../../Shared/Entities/Constants/AlertConstants";
import { MoneyTextBoxEditor } from "../../../../../../../react-core/Html/Money/MoneyTextBoxEditor";
import { OneOffIncomeTable } from "../../../NewOneOffIncomePaymentWizard/Components/Shared/OneOffIncomeTable";
import { SelectEditor } from "../../../../../../../react-core/Html/SelectEditor";
import { PaymentMethodArraysMap, PaymentMethodTypeOptions } from "../../../Common/Resource/Contents";
import { PaymentMethod } from "../../../../../../../Wrap/Constants/Enums/Domain/PaymentMethod";
import { BankDetails } from "../../../NewOneOffIncomePaymentWizard/Components/Shared/BankDetails";
import { CalculateEstimatedPaye } from "../../../NewOneOffIncomePaymentWizard/Components/Shared/CalculateEstimatedPaye";
import { PartLoading } from "../../../../../../../react-core/Html/PartLoading";
import { PensionContribution } from "../../../../../../../Wrap/Models/Models/Processes/Apply/Pension/PensionContribution";
import _ from "lodash";
import { PensionEstimatedPayQuery } from "../../../../../../../Wrap/Models/Domains/Tax/PensionEstimatedPayQuery";
import { getQueryParameters } from "../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { PensionIncomeConfiguration } from "../../../../../../../Wrap/Constants/Enums/Domain/PensionIncomeConfiguration";
import { Frequency } from "../../../../../../../Wrap/Constants/Enums/Domain/Frequency";
import { JsonDateParser } from "../../../../../../../react-core/Utils/JsonDateParser";
import { IncomePaymentDestination } from "../../../../../../../Wrap/Constants/Enums/Domain/IncomePaymentDestination";
import { IncomePaymentOneOffPaymentType } from "../../../../../../../Wrap/Constants/Enums/Domain/IncomePaymentOneOffPaymentType";
import { IncomePaymentSourceFrom } from "../../../../../../../Wrap/Constants/Enums/Domain/IncomePaymentSourceFrom";

interface IIncomePaymentOneOffProps extends IProcessComponentProps {
    customerId?: number;
    extraInfo?: any;
    isLoading?: boolean;
}

interface IIncomePaymentOneOffPropsState {
    userInfo: User;
}

export class IncomePaymentOneOffDetail extends ProcessComponent<
    IIncomePaymentOneOffProps,
    IIncomePaymentOneOffPropsState
> {
    constructor(props: any) {
        super(props);
        this.state = {
            userInfo: UserStore.getUserInfo()
        };

        this.bindFunctions();
    }

    componentDidMount() {
        super.componentDidMount();
        const payment = this.getModel()?.Instruction?.Payment;

        if (payment?.IncomePaymentOneOffPaymentType == IncomePaymentOneOffPaymentType.NotSpecified) {
            this.onPaymentTypeChange(IncomePaymentOneOffPaymentType.AvailableCash);
        }
        this.updateCashAllocation(payment?.IncomePaymentOneOffPaymentType);
    }

    private updateCashAllocation(paymentType: IncomePaymentOneOffPaymentType) {
        const model = this.getModel();
        if (
            paymentType === IncomePaymentOneOffPaymentType.AvailableCash &&
            model.CashAvailable?.Amount > 0 &&
            model.CashInstrument?.ProductId
        ) {
            const cashAllocation: InvestmentAllocation[] = [{
                ProductId: model.CashInstrument.ProductId,
                Percentage: 100
            }];

            const instruction = this.getModel()?.Instruction ?? {};
            instruction.DisinvestmentAllocations = cashAllocation;
            this.onDataChange(this.onDrawdownSinglePaymentInstructionChange, cashAllocation, instruction, "DisinvestmentAllocations");
        }
    }

    private bindFunctions() {
        this.getModel = this.getModel.bind(this);
        this.getPayment = this.getPayment.bind(this);
        this.onContributionChange = this.onContributionChange.bind(this);
        this.onOneOffIncomePaymentModelChange = this.onOneOffIncomePaymentModelChange.bind(this);
        this.onInstructionChange = this.onInstructionChange.bind(this);
        this.onArrangementSelectionChange = this.onArrangementSelectionChange.bind(this);
        this.onDrawdownPaymentDestinationAllocationChange = this.onDrawdownPaymentDestinationAllocationChange.bind(
            this
        );
        this.onPaymentChange = this.onPaymentChange.bind(this);
        this.onDrawdownSinglePaymentInstructionChange = this.onDrawdownSinglePaymentInstructionChange.bind(this);
        this.onPaymentAmountChange = this.onPaymentAmountChange.bind(this);
        this.onDisinvestmentAllocationsChange = this.onDisinvestmentAllocationsChange.bind(this);
    }

    public isValid(): boolean {
        return super.isValid() && !RestrictionStore.WithdrawDisabled();
    }

    private onContributionChange(newData: PensionContribution): void {
        const { onChange, data } = this.props;
        this.onDataChange(onChange, newData, data, "Contribution");
    }

    private onOneOffIncomePaymentModelChange(newData: OneOffIncomePaymentModel): void {
        const contribution = this.props.data?.Contribution;
        this.onDataChange(this.onContributionChange, newData, contribution, "OneOffIncomePaymentModel");
    }

    private onInstructionChange(newData: DrawdownSinglePaymentInstruction): void {
        const oneOffIncomePaymentModel = this.props.data?.Contribution?.OneOffIncomePaymentModel;
        this.onDataChange(this.onOneOffIncomePaymentModelChange, newData, oneOffIncomePaymentModel, "Instruction");
    }

    private onArrangementSelectionChange(newAllocations: DrawdownPaymentSourceAllocation[]): void {
        const payment = this.getModel()?.Instruction?.Payment;
        if (payment == null || isNullOrEmpty(payment?.PaymentSourceAllocations)) {
            this.onPaymentChange({ PaymentSourceAllocations: newAllocations });
            return;
        }
        this.onDataChange(this.onPaymentChange, newAllocations, payment, "PaymentSourceAllocations");
    }

    private onDrawdownPaymentDestinationAllocationChange(newAllocations: DrawdownPaymentDestinationAllocation[]): void {
        const payment = this.getModel()?.Instruction?.Payment;
        if (payment == null || isNullOrEmpty(payment?.PaymentDestinationAllocations)) {
            this.onPaymentChange({ PaymentDestinationAllocations: newAllocations });
            return;
        }
        this.onDataChange(this.onPaymentChange, newAllocations, payment, "PaymentDestinationAllocations");
    }

    private onPaymentChange(newData: DrawdownSinglePayment): void {
        const instruction = this.getModel()?.Instruction;
        this.onDataChange(this.onDrawdownSinglePaymentInstructionChange, newData, instruction, "Payment");
    }

    private onDrawdownSinglePaymentInstructionChange(newData: DrawdownSinglePaymentInstruction): void {
        const instruction = this.getModel()?.Instruction;
        this.onDataChange(this.onInstructionChange, newData, instruction);
    }

    private onPaymentAmountChange(newData: number): void {
        const payment = this.getModel()?.Instruction?.Payment;

        if (payment == null) {
            this.onPaymentChange({
                Amount: { Amount: newData, Currency: CurrencyCode.GBP },
                PaymentSourceAllocations: [],
                PaymentDestinationAllocations: []
            });
            return;
        }

        let newPaymentAmount: Money;

        if (payment.Amount) {
            newPaymentAmount = { Amount: newData, Currency: payment.Amount.Currency };
        } else {
            newPaymentAmount = { Amount: newData, Currency: CurrencyCode.GBP };
        }

        this.onDataChange(this.onPaymentChange, newPaymentAmount, payment, "Amount");
    }

    private onDisinvestmentAllocationsChange(newAllocation: Money, productId: number): void {
        const clonedInstruction = _.clone(this.getModel()?.Instruction ?? {});

        const unchangedAllocation =
            clonedInstruction?.DisinvestmentAllocations?.filter((x) => x.ProductId != productId) ?? [];
        const allocation: InvestmentAllocation = { ProductId: productId, Value: newAllocation };
        unchangedAllocation.push(allocation);

        const updatedTotalValue = unchangedAllocation.reduce((sum, allocation) => sum + allocation.Value.Amount, 0);

        clonedInstruction.DisinvestmentAllocations = unchangedAllocation;
        if (clonedInstruction.Payment == null) {
            clonedInstruction.Payment = {
                Amount: { Amount: updatedTotalValue, Currency: CurrencyCode.GBP },
                PaymentSourceAllocations: [],
                PaymentDestinationAllocations: []
            };
        } else {
            clonedInstruction.Payment.Amount = { Amount: updatedTotalValue, Currency: CurrencyCode.GBP };
        }
        this.onDataChange(this.onInstructionChange, clonedInstruction, this.getModel()?.Instruction ?? {})
    }

    private onPaymentTargetSpecificArrangementsChange(targetSpecificArrangements: boolean): void {
        const payment = this.getModel()?.Instruction?.Payment;
        if (payment == null) {
            this.onPaymentChange({ TargetSpecificArrangements: targetSpecificArrangements });
            return;
        }
        payment.TargetSpecificArrangements = targetSpecificArrangements
        this.onPaymentChange(payment);
    }
    private onPaymentTypeChange(paymentType: IncomePaymentOneOffPaymentType): void {
        const payment = this.getModel()?.Instruction?.Payment;

        if (payment == null) {
            if (paymentType == IncomePaymentOneOffPaymentType.AssetsAndAvailableCash && payment.IncomePaymentSourceFrom == IncomePaymentSourceFrom.NotSpecified) {
                this.onPaymentChange({
                    IncomePaymentOneOffPaymentType: paymentType,
                    IncomePaymentSourceFrom: IncomePaymentSourceFrom.SpecifyAmount
                });
            } else {
                this.onPaymentChange({
                    IncomePaymentOneOffPaymentType: paymentType
                });
            }

            return;
        }

        payment.IncomePaymentOneOffPaymentType = paymentType;
        if (paymentType == IncomePaymentOneOffPaymentType.AssetsAndAvailableCash && payment.IncomePaymentSourceFrom == IncomePaymentSourceFrom.NotSpecified) {
            payment.IncomePaymentSourceFrom = IncomePaymentSourceFrom.SpecifyAmount
        }

        this.onPaymentChange(payment);
    }

    private onPaymentSourceChange(paymentSource: IncomePaymentSourceFrom): void {
        const payment = this.getModel()?.Instruction?.Payment;

        if (payment == null) {
            this.onPaymentChange({
                IncomePaymentSourceFrom: paymentSource
            });
            return;
        }

        payment.IncomePaymentSourceFrom = paymentSource;

        this.onPaymentChange(payment);
    }

    public hasInheritedDrawdowns(): boolean {
        const flexi = this.getFlexiList().some((a) => a?.PensionArrangementDetail?.IsInherited);
        const capped = this.getCappedList().some((a) => a?.PensionArrangementDetail?.IsInherited);
        return flexi || capped;
    }

    private getPayment(): DrawdownSinglePayment {
        return this.getModel().Instruction?.Payment;
    }

    private getFlexiList(): FlexiPensionArrangementDetail[] {
        return this.getModel().FlexiPensionArrangements ?? [];
    }

    private getCappedList(): CappedPensionArrangementDetail[] {
        return this.getModel().CappedPensionArrangements ?? [];
    }

    private getArrangementSelection(): DrawdownPaymentSourceAllocation[] {
        return this.getModel().Instruction?.Payment?.PaymentSourceAllocations ?? [];
    }

    private getModel(): OneOffIncomePaymentModel {
        return this.props.data?.Contribution?.OneOffIncomePaymentModel ?? {};
    }

    private getDataForAssetsAllocationTable(): UserAssetsAllocationData[] {
        const model = this.getModel();
        const accountHoldings = model.Holdings ?? [];
        const allocations = accountHoldings.map((h) => {
            const availableValue = toDp((h.MarketValue.Amount / h.Quantity) * h.AvailableQuantity, 2);
            const availableMarketValue: Money = { Amount: availableValue, Currency: h.MarketValue.Currency };

            return {
                AssetId: h.ProductId,
                Investment: h.ProductCode,
                AvailableMarketValue: availableMarketValue,
                Allocation: null,
                SecurityType: h.SecurityType
            };
        });
        const disinvestmentAllocations =
            model.Instruction?.DisinvestmentAllocations ?? [];

        if (isNullOrEmpty(disinvestmentAllocations)) {
            return allocations;
        }

        const disinvestmentDict = {};
        disinvestmentAllocations.forEach((x) => (disinvestmentDict[x.ProductId] = x));

        allocations.forEach((a) => {
            const disinvestment = disinvestmentDict[a.AssetId];
            if (disinvestment) {
                a.Allocation = disinvestment.Value;
            }
        });

        return allocations;
    }

    private clientDetailRender() {
        const data = this.getModel();

        const config = [
            {
                title: "Total estimated value available",
                data: MoneyDisplayHelper.getMoneyFormat(data?.TotalEstimatedValueAvailable ?? { Amount: 0, Currency: CurrencyCode.GBP }),
            },
            {
                title: "Which is made up of:",
                data: " ",
            },
            {
                title: "Available cash",
                data: MoneyDisplayHelper.getMoneyFormat(data?.CashAvailable ?? { Amount: 0, Currency: CurrencyCode.GBP }),
            },
            {
                title: "Estimated asset value available",
                data: MoneyDisplayHelper.getMoneyFormat(data?.EstimatedAssetValueAvailable ?? { Amount: 0, Currency: CurrencyCode.GBP }),
            },
        ];
        return (
            <div>
                <div className="d-flex flex-space">
                    <h2 className="mb-11">Income payment details</h2>
                </div>

                <Typography type="common" config={config}></Typography>
            </div>
        );
    }

    private getCalculateEstimatedPayeQueries(): Array<PensionEstimatedPayQuery> {

        if (this.getPayment()?.TargetSpecificArrangements) {
            var queryList: Array<PensionEstimatedPayQuery> = [];
            var allocations = this.getPayment()?.PaymentSourceAllocations ?? [];
            allocations.forEach(allocation => {
                if (allocation?.Amount?.Amount > 0) {
                    queryList.push(
                        {
                            HierarchyId: getQueryParameters()["subaccounthierarchyid"],
                            PensionArrangementId: allocation.ArrangementId,
                            PensionIncomeConfiguration: PensionIncomeConfiguration.ArrangementLevel,
                            GrossAmount: allocation?.Amount,
                            Frequency: Frequency.Monthly,
                            PaymentDate: JsonDateParser.toJsonDate(new Date()) //TBC
                        }
                    )
                }
            })
            return queryList;
        }
        else {
            return [
                {
                    HierarchyId: getQueryParameters()["subaccounthierarchyid"],
                    PensionIncomeConfiguration: PensionIncomeConfiguration.PensionLevel,
                    GrossAmount: this.getPayment()?.Amount,
                    Frequency: Frequency.Monthly,
                    PaymentDate: JsonDateParser.toJsonDate(new Date())
                }]
        }
    }

    render() {
        const { onChange } = this.props;
        const data = this.getModel();
        const payment = data?.Instruction?.Payment;

        if (this.props.isLoading) {
            return <PartLoading isLoading={true}></PartLoading>;
        }

        let restrictedMessage = "An account with suspended or restricted activities cannot setup withdrawals";

        if (this.state.userInfo != null && this.state.userInfo.IsAdviser) {
            restrictedMessage = GENERIC_RESTRICTIONS_MESSAGE;
        }

        const hasBankDestination = payment?.PaymentDestinationAllocations?.some(alloc => alloc.Destination == IncomePaymentDestination.BankAccount);

        return (
            <div>
                {RestrictionStore.WithdrawDisabled() && (
                    <Alert alertType={AlertType.Error} message={restrictedMessage} />
                )}
                {this.clientDetailRender()}
                <hr className="heading-underlined-text"></hr>

                <RadiosEditor
                    cssWrapper="rg-inline mb-16"
                    label={"Do you wish to target specific arrangements?"}
                    tooltip="Where a customer has more than one drawdown arrangement, you are able to choose which arrangements are used to provide income withdrawals. Selecting specific arrangements can be beneficial for clients who have inherited drawdown benefits which have different tax treatments. Or you can select 'No' and the platform will automatically choose the arrangements to be used."
                    selected={this.getPayment()?.TargetSpecificArrangements ?? false}
                    disabled={false}
                    options={[true, false]}
                    getText={(v) => (v ? "Yes" : "No")}
                    onChange={(v) => {
                        this.onPaymentTargetSpecificArrangementsChange(v);
                    }}
                    required={"Please select "}
                />
                {this.hasInheritedDrawdowns() && (
                    <Alert
                        alertType={AlertType.Warning}
                        message={
                            " SL to provide content around whether the inherited drawdowns should be targeted or excluded and they should consider the use of the standard algorithm or targeting arrangements"
                        }
                    />
                )}

                <div className="d-flex flex-space">
                    <h2 className="mb-11">Payment type</h2>
                </div>
                <RadiosEditor
                    cssWrapper="rg-inline mb-16"
                    label=""
                    options={getPaymentTypeOptions()}
                    getText={(option) => getString(option)}
                    onChange={(v) => {
                        const instruction = this.getModel()?.Instruction ?? {};
                        this.onPaymentTypeChange(v)
                        if (v === IncomePaymentOneOffPaymentType.AvailableCash) {
                            this.updateCashAllocation(v);
                        } else {
                            instruction.DisinvestmentAllocations = [];
                            this.onDataChange(this.onDrawdownSinglePaymentInstructionChange, [], instruction, "DisinvestmentAllocations");
                        }
                    }}
                    selected={payment?.IncomePaymentOneOffPaymentType}
                    required={"Please select Payment Type"}
                />

                {!this.getPayment()?.TargetSpecificArrangements && 
                <div className="row">
                    <div className="col-sm-4 col-12 pb-20">
                        <h3 className="mb-11">Maximum estimated income payment available from the pension</h3>
                    </div>
                    <div className="col-sm-4 col-12">
                        <span>
                            {payment?.IncomePaymentOneOffPaymentType == IncomePaymentOneOffPaymentType.AvailableCash
                                ? MoneyDisplayHelper.getMoneyFormat(
                                    data.CashAvailable.Amount < data.StandardAlgorithmAvailable.Amount
                                        ? data.CashAvailable
                                        : data.StandardAlgorithmAvailable
                                )
                                : MoneyDisplayHelper.getMoneyFormat(
                                    data.TotalEstimatedValueAvailable.Amount < data.StandardAlgorithmAvailable.Amount
                                        ? data.TotalEstimatedValueAvailable
                                        : data.StandardAlgorithmAvailable
                                )}
                        </span>
                    </div>
                </div>}
                <div className="d-flex flex-space">
                    <h2 className="mb-11">Payment amount from the pension</h2>
                </div>
                {payment?.IncomePaymentOneOffPaymentType == IncomePaymentOneOffPaymentType.AssetsAndAvailableCash && <RadiosEditor
                    cssWrapper="rg-inline mb-16"
                    label=""
                    options={getSourceFromOptions()}
                    getText={(option) => getSourceFromString(option)}
                    onChange={(v) => {
                        this.onPaymentSourceChange(v)
                    }}
                    alwaysValidateOnUpdate={false}
                    selected={payment?.IncomePaymentSourceFrom}
                    required={"Please select Payment Source"}
                />}

                {!this.getPayment()?.TargetSpecificArrangements 
                && (payment?.IncomePaymentOneOffPaymentType == IncomePaymentOneOffPaymentType.AvailableCash || payment?.IncomePaymentSourceFrom == IncomePaymentSourceFrom.SpecifyAmount) 
                && <div className="col-md-4 col-12">
                    <MoneyTextBoxEditor
                        required={"Please enter payment amount"}
                        value={this.getPayment()?.Amount?.Amount ?? 0}
                        currency={this.getPayment()?.Amount?.Currency ?? CurrencyCode.GBP}
                        label={""}
                        alwaysValidateOnUpdate={false}
                        onChange={(v) => {
                            this.onPaymentAmountChange(v);
                        }}
                        validationRules={[
                            {
                                errorMessage: "value must be > 0",
                                validator: (v) => v > 0,
                            },
                            {
                                errorMessage:
                                    "value can't be greater than maximum estimated income payment available from the pension",
                                validator: (v) => {
                                    if (
                                        payment?.IncomePaymentOneOffPaymentType ==
                                        IncomePaymentOneOffPaymentType.AvailableCash
                                    ) {
                                        return v <= data.CashAvailable.Amount;
                                    } else {
                                        return v <= data.TotalEstimatedValueAvailable.Amount;
                                    }
                                },
                            },
                        ]}
                    />
                </div>}
                {payment?.IncomePaymentOneOffPaymentType == IncomePaymentOneOffPaymentType.AssetsAndAvailableCash && payment?.IncomePaymentSourceFrom == IncomePaymentSourceFrom.SpecifyAssetorCash && (
                    <UserAssetsAllocationTable
                        totalValue={this.getPayment()?.Amount}
                        maximumEstimatedAmount={data.TotalEstimatedValueAvailable.Amount}
                        data={this.getDataForAssetsAllocationTable()}
                        onChange={this.onDisinvestmentAllocationsChange}
                        onRef={(ref) => this.appendChild(ref)}
                        showErrorMsgPopUp={this.props.showErrorMsgPopUp}
                    />
                )}

                {payment?.TargetSpecificArrangements && this.getCappedList().length > 0 && (
                    <OneOffIncomeTable
                        cssWrapper=""
                        tableTitle="Capped"
                        ArrangementType={IncomeArrangementType.Capped}
                        data={this.getCappedList()}
                        arrangementSelection={this.getArrangementSelection()}
                        onChange={this.onArrangementSelectionChange}
                        onRef={(ref) => this.appendChild(ref)}
                    />
                )}
                {payment?.TargetSpecificArrangements && this.getFlexiList().length > 0 && (
                    <OneOffIncomeTable
                        cssWrapper=""
                        tableTitle="Flexible"
                        ArrangementType={IncomeArrangementType.Flexi}
                        data={this.getFlexiList()}
                        arrangementSelection={this.getArrangementSelection()}
                        onChange={this.onArrangementSelectionChange}
                        onRef={(ref) => this.appendChild(ref)}
                    />
                )}

                {hasBankDestination && <div className="row">
                    <div className="col-sm-4 col-12 pb-20">
                        <SelectEditor
                            label={"Payment method"}
                            options={PaymentMethodTypeOptions}
                            selected={PaymentMethod.Bacs}
                            getText={(v) => {
                                return PaymentMethodArraysMap[v];
                            }}
                            onChange={(v) => {
                                this.onDataChange(onChange, v, data, "PaymentMethod");
                            }}
                        />
                    </div>
                </div>}

                <CalculateEstimatedPaye query={this.getCalculateEstimatedPayeQueries()} />
                <hr className="heading-underlined-text"></hr>
                {
                    <BankDetails
                        ownerHierarchyId={data?.Instruction?.HierarchyId}
                        allBankAccounts={this.props.extraInfo?.AllBankAccounts ?? []}
                        incomePaymentAllocations={
                            data?.Instruction?.Payment
                                ?.PaymentDestinationAllocations ?? []
                        }
                        onChange={this.onDrawdownPaymentDestinationAllocationChange}
                        onRef={(ref) => this.appendChild(ref)}
                        showErrorMsgPopUp={this.props.showErrorMsgPopUp}
                        data={data}
                    />
                }
            </div>
        );
    }
}
